import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Inairequipment from '../entities/inairequipment'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface InairequipmentState extends ListState<Inairequipment>{
    editInairequipment:Inairequipment,
    analyseInairequipment: Inairequipment
}
class UserMutations extends ListMutations<Inairequipment>{

}
class InairequipmentModule extends ListModule<InairequipmentState,any,Inairequipment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Inairequipment>(),
        loading:false,
        analyseInairequipment:new Inairequipment(),
        editInairequipment:new Inairequipment()
    }
    actions={
        async getPage(context:ActionContext<InairequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getDataforExcel(context:ActionContext<InairequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairequipment>;
            return page.items;
        },
        async getCountHome(context:ActionContext<InairequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetCountHome');
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairequipment>;
            return page;
        },
        async getCountHomeEchart(context:ActionContext<InairequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetCountHomeEchart');
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairequipment>;
            return page;
        },
        async GetRealPaged(context:ActionContext<InairequipmentState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetRealPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return page.items;
        },
        async GetGlobalPaged(context:ActionContext<InairequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetGlobalPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getAll(context:ActionContext<InairequipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Inairequipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getEquList(context:ActionContext<InairequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetEquList',{params:payload.data});
            return reponse.data.result;
        },
        async create(context:ActionContext<InairequipmentState,any>,payload:any){
            await Ajax.post('/api/services/app/InairEquipment/Create',payload.data);
        },
        async uploadimg(context:ActionContext<InairequipmentState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<InairequipmentState,any>,payload:any){
            await Ajax.put('/api/services/app/InairEquipment/Update',payload.data);
        },
        async delete(context:ActionContext<InairequipmentState,any>,payload:any){
            await Ajax.delete('/api/services/app/InairEquipment/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<InairequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetById?Id='+payload.id);
            return reponse.data.result as Inairequipment;
        },
        ///获取设备数量
        async getCount(context:ActionContext<InairequipmentState,any>,payload:any){
            //console.log(payload);
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetCount?status='+payload.data.status);
            return reponse.data.result.count;
        },
        //通过mac获取设备
        async getPageBymac(context:ActionContext<InairequipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/InairEquipment/GetPaged',{params:payload.data});
            return reponse.data.result.items as Inairequipment;
        }
    };
    mutations={
        setCurrentPage(state:InairequipmentState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:InairequipmentState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: InairequipmentState, inairequipment: Inairequipment) {
            state.analyseInairequipment = inairequipment;
        },
        edit(state:InairequipmentState,inairequipment:Inairequipment){
            
            state.editInairequipment=inairequipment;
            //console.log(state.editFloor);
        }
    }
}
const inairequipmentModule=new InairequipmentModule();
export default inairequipmentModule;